import * as React from 'react';
import { StyledModalOverlay } from './styles/ModalStyles';
var Overlay = function (_a) {
    var children = _a.children, styles = _a.styles, testId = _a.testId;
    return (React.createElement(StyledModalOverlay, { "data-testid": "".concat(testId, "-overlay"), style: styles }, children));
};
export default Overlay;
//# sourceMappingURL=Overlay.js.map